import React, {useState} from "react"
import config from "../../config"

import "./Config.scss"

function Config() {
  const [sidebarPosition, setSidebarPosition] = useState(config.layout.sidebarPosition)
  
  const selectSidebarPosition = (p) => {
    config.layout.sidebarPosition = p
    setSidebarPosition(p)
  }

  return (
    <div id="v-config">
      <div className="section">
        <h1>Sidebar Position</h1>
        <div className="selector">
          <div onClick={() => selectSidebarPosition('left')} className={`item ${sidebarPosition === "left" ? "selected" : ""}`}>left</div>
          <div onClick={() => selectSidebarPosition('right')} className={`item ${sidebarPosition === "right" ? "selected" : ""}`}>right</div>
          <div onClick={() => selectSidebarPosition('mixed')} className={`item ${sidebarPosition === "mixed" ? "selected" : ""}`}>mixed</div>
        </div>
      </div>

    </div>
  )
}

export default Config